import Vue from 'vue'
import VueRouter from 'vue-router'
import { i18n } from '../lang'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Recharge  from '../pages/mine/Recharge'/* 充值页 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import AccountDetail  from '../pages/mine/AccountDetail'/* 账号明细 */




Vue.use(VueRouter)
// 约定：每条路由 meta 需同时含 title（中文兜底，LangSwitch 切语言时用）与 titleKey（守卫设 document.title 的唯一真相源）
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'首页',titleKey:'router.Index.title'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'首页',titleKey:'router.Home.title'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'选妃',titleKey:'router.Choose.title'}},
	{path:'/List',name:'list',component:List,meta:{title:'选妃列表',titleKey:'router.List.title'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'选妃详情',titleKey:'router.Profile.title'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'我的',titleKey:'router.Mine.title'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'视频',titleKey:'router.Video.title'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'游戏',titleKey:'router.Game.title'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'登录',titleKey:'router.Login.title'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'注册',titleKey:'router.Register.title'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'在线客服',titleKey:'router.ServiceOnline.title'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'在线客服',titleKey:'router.ServicePage.title'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'设置',titleKey:'router.Setting.title'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'基本信息',titleKey:'router.Infomation.title'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'修改真实姓名',titleKey:'router.Setname.title'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'修改性别',titleKey:'router.Setsex.title'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'支付密码管理',titleKey:'router.SetPayPassword.title'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'登录密码管理',titleKey:'router.SetLoginPassword.title'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'详情页面',titleKey:'router.Lottery.title'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'信息公告',titleKey:'router.Notice.title'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'视频播放',titleKey:'router.PlayVideo.title'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'填写收款卡',titleKey:'router.Setbank.title'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'填写收款卡',titleKey:'router.BindCard.title'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'提现',titleKey:'router.Withdraw.title'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'充值',titleKey:'router.Recharge.title'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'个人报表',titleKey:'router.Personalreport.title'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'提现记录',titleKey:'router.WithdrawRecord.title'}},
    {path:'/AccountDetail',name:'AccountDetail',component:AccountDetail,meta:{title:'账号明细',titleKey:'router.AccountDetail.title'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'任务记录',titleKey:'router.GameRecord.title'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    // i18n: titleKey 为唯一真相源；meta.title 中文仅作语言包缺 key 兜底，不再被本守卫读取
    // to.matched 可能为空数组（未定义路径），取 [0] 前必须保护
    const m = to.matched.length ? to.matched[0].meta : {}
    document.title = i18n.t(m.titleKey || 'common.appName')
    next()
})

export default router
